import { Button, Divider, Flex, Typography } from 'antd';
import _ from 'lodash';
import TransactionIcon from '../components/TransactionIcon';
import {
  Transaction,
  TransactionStatus,
  TransactionType,
} from 'widgets/transactions/model/types';
import classes from './Transactions.module.scss';
import { useIntl } from 'react-intl';
import { SwapOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

export default function TransactionListItem({
  transaction,
  onClick,
}: {
  transaction: Transaction;
  onClick: (transaction: Transaction) => unknown;
}) {
  const { formatMessage: t } = useIntl();
  const navigate = useNavigate();

  const isPayAgainAvailable = (transaction: Transaction) => {
    return (
      (transaction.type === TransactionType.WithdrawSepa ||
        transaction.type === TransactionType.SendDebit) &&
      (transaction.status === TransactionStatus.Pending ||
        transaction.status === TransactionStatus.Approved) &&
      transaction.iban
    );
  };

  const formatAmount = (amount: number) => {
    return amount < 0
      ? `${Number(amount).toFixed(2)}\u00A0€`
      : `+${Number(amount).toFixed(2)}\u00A0€`;
  };

  const payAgain = (item: Transaction) => {
    navigate('/pro/send/sepa', { state: { currentTemplate: item } });
  };

  return (
    <Flex
      key={transaction.id}
      onClick={() => onClick(transaction)}
      vertical
      className={classes['transaction']}>
      <Flex justify="space-between" align="center" style={{ padding: '8px' }}>
        <Flex gap={12} align="center">
          <div className={classes['icon-wrap']}>
            <TransactionIcon
              size={40}
              type={transaction.type}
              status={transaction.status}
            />
          </div>
          <Flex vertical gap={2}>
            <Typography.Text className={classes['transaction__recipient']}>
              {_.startCase(transaction.description || transaction.details)}
            </Typography.Text>
            <Typography.Text className={classes['transaction__description']}>
              {transaction.created?.slice(10)} {transaction.status === TransactionStatus.Declined && ` · declined`}
            </Typography.Text>
            {isPayAgainAvailable(transaction) && (
              <Button
                icon={<SwapOutlined style={{ fontSize: 14 }} />}
                size="small"
                type="link"
                className={classes['pay-again']}
                onClick={(event) => {
                  event.stopPropagation();
                  payAgain(transaction);
                }}>
                {t({ id: 'mobile.payments.button.payAgain' })}
              </Button>
            )}
          </Flex>
        </Flex>
        <Typography.Text
          className={classes['no-break']}
          strong
          type={
            transaction.status === TransactionStatus.Declined
              ? 'danger'
              : transaction.status === TransactionStatus.Pending
                ? 'secondary'
                : transaction.amount < 0
                  ? 'danger'
                  : 'success'
          }>
          {formatAmount(transaction.amount)}
        </Typography.Text>
      </Flex>
      <Divider style={{ margin: 0 }} />
    </Flex>
  );
}
